module.exports = __webpack_public_path__ + "media/images/country_flags/eh-79306c61c859d76f2ff41d9215ed57b6.png";